import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PrivacyPolicyEN from 'lifesum-web/src/js/components/privacy-policy/PrivacyPolicyEN'
import PrivacyPolicyUS from 'lifesum-web/src/js/components/privacy-policy/PrivacyPolicyUS'
import PrivacyPolicyDE from 'lifesum-web/src/js/components/privacy-policy/PrivacyPolicyDE'
import Header from 'components/Header'
import { getUserCountry } from 'lifesum-web/src/js/auth/getUserCountry'
import { getCountry } from 'lib/params'

function MainView({ language = 'en' }) {
  const [country, setCountry] = useState(getCountry())
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getUserCountry().then((country) => {
      if (country === 'US') setCountry('US')
      setIsLoading(false)
    })
  }, [])

  return (
    <div className="bg-BgSub text-Type">
      {isLoading ? (
        <Header
          title={
            <img
              src={require('media/loader.gif')}
              alt="Loading…"
              className="h-72 w-72"
            />
          }
        />
      ) : (
        <>
          <Header
            title={
              country === 'US'
                ? 'Privacy Policy'
                : language === 'de' || country === 'DE'
                ? 'AGB & Datenschutz'
                : 'Privacy Policy & Terms of Service'
            }
          />
          <div className="s-text o-width-limiter w-screen overflow-hidden px-16 pb-64">
            {country === 'US' ? (
              <PrivacyPolicyUS />
            ) : language === 'de' || country === 'DE' ? (
              <PrivacyPolicyDE />
            ) : (
              <PrivacyPolicyEN />
            )}
          </div>
        </>
      )}
    </div>
  )
}

MainView.propTypes = {
  language: PropTypes.string,
  country: PropTypes.string,
}

export default MainView
